import { Injectable } from '@angular/core';
import { AngularFireRemoteConfig } from '@angular/fire/compat/remote-config';

@Injectable({
  providedIn: 'root'
})
export class PhoneService {

  private supportPhoneNumber: string;

  constructor(private remoteConfig: AngularFireRemoteConfig) {
    // obtain support phone number from remote config
    remoteConfig.strings.supportPhoneNumber.subscribe(v => {
      console.log(`Remote config: supportPhoneNumber = ${v}`);
      this.supportPhoneNumber = v;
    });
  }

  /**
   * Call the support phone number, as specified by the environment variable
   */
  callSupport(): void {
    this.call(this.supportPhoneNumber);
  }

  /**
   * Call any phone number
   *
   * @param phoneNumber Phone number
   */
  call(phoneNumber: string): void {
    const element = document.createElement('a');
    element.setAttribute('href', `tel:${phoneNumber}`);
    element.click();
  }
}
